export const FILE_FORMATS_BY_CONTENT_TYPE = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.ms-excel': 'xls',
  'application/msword': 'doc',
  'text/csv': 'csv',
  'text/csv; charset=utf-8': 'csv',
  'application/pdf': 'pdf',
  'application/zip': 'zip',
};

export const extractAfter = (url, marker) => {
  const index = url.indexOf(marker);
  if (index === -1) return '';
  return url.substring(index + marker.length);
};
